import { compose, pathOr, toUpper, concat } from 'rambda';

export const getMaskedAccountId = compose(
  concat('*****'),
  a => a.substring(a.length - 5),
  pathOr<string>('', 'icam.data.profile.person.icamUuid')
);

export const getLoginEmail = compose(
  toUpper,
  pathOr('', 'data.profile.person.loginEmail')
);

export const getLegacy = compose(Boolean, pathOr(0, 'data.profile.person.indivId'));
